// Import model
import { DataviewPromptResponse } from '../models/DataviewPromptResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterPromptRequest } from '../models/FilterPromptRequest';
import { Prompt } from '../models/Prompt';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterPromptRequestSerializer } from './FilterPromptRequestSerializer';
import { PromptSerializer } from './PromptSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewPromptResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewPromptResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewPromptResponse instance
   */
  static deserialize(json: string): DataviewPromptResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewPromptResponse instance
   */
  static fromObject(obj: any): DataviewPromptResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewPromptResponse');
    }


    const instance: DataviewPromptResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        PromptSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterPromptRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewPromptResponse instances
   */
  static deserializeArray(json: string): DataviewPromptResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewPromptResponse instance to a JSON string
   */
  static serialize(instance: DataviewPromptResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewPromptResponse instance to a plain object
   */
  static toObject(instance: DataviewPromptResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        PromptSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterPromptRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewPromptResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewPromptResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
